import React from "react";
import { useBilling } from "../store/BillingContext";
import { money } from "../lib/utils";

export const ServicesView: React.FC = () => {
  const { state, setActiveForm, deleteService } = useBilling();

  const categories = Array.from(new Set(state.services.map((s) => s.category || "General")));

  return (
    <section className="panel">
      <div className="panel-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h3>Services & Rate Card ({state.services.length} items)</h3>
        <button
          className="primary"
          onClick={() =>
            setActiveForm({
              kind: "service",
              value: {
                id: "",
                name: "",
                category: "Website Development",
                rate: 15000,
                billing: "monthly",
                hsn: "998314",
                description: "",
              },
            })
          }
        >
          <i className="fa-solid fa-plus" /> + Add New Service
        </button>
      </div>

      {categories.map((category) => {
        const items = state.services.filter((s) => (s.category || "General") === category);

        return (
          <div key={category} style={{ marginBottom: "28px" }}>
            <h4
              style={{
                fontSize: "13px",
                textTransform: "uppercase",
                letterSpacing: "0.8px",
                color: "#173b60",
                borderBottom: "2px solid #e2e8f0",
                paddingBottom: "8px",
                margin: "18px 0 12px",
              }}
            >
              {category} ({items.length})
            </h4>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {items.map((s) => (
                <div
                  key={s.id}
                  style={{
                    background: "#ffffff",
                    border: "1px solid #e2e8f0",
                    borderRadius: "10px",
                    padding: "16px 20px",
                    display: "grid",
                    gridTemplateColumns: "1fr auto",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                      <span className="badge">{s.category}</span>
                      {s.hsn && (
                        <span style={{ fontSize: "11px", color: "#64748b", background: "#f1f5f9", padding: "2px 6px", borderRadius: "4px" }}>
                          SAC: {s.hsn}
                        </span>
                      )}
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: 600,
                          color: s.billing === "monthly" ? "#0369a1" : "#047857",
                          background: s.billing === "monthly" ? "#e0f2fe" : "#dcfce7",
                          padding: "2px 8px",
                          borderRadius: "10px",
                        }}
                      >
                        {s.billing === "monthly" ? "Monthly Retainer" : "One-Time Project"}
                      </span>
                    </div>

                    <h3 style={{ margin: "8px 0 4px", fontSize: "16px", color: "#0f172a" }}>{s.name}</h3>
                    {s.description && (
                      <p style={{ margin: "0 0 8px", color: "#64748b", fontSize: "13px" }}>{s.description}</p>
                    )}

                    {s.features && s.features.length > 0 && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginTop: "6px" }}>
                        {s.features.map((f, idx) => (
                          <span
                            key={idx}
                            style={{
                              fontSize: "11px",
                              color: "#475569",
                              background: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: "4px",
                              padding: "2px 6px",
                            }}
                          >
                            ✓ {f}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={{ textAlign: "right", minWidth: "160px" }}>
                    <b style={{ fontSize: "20px", color: "#173b60", display: "block" }}>{money(s.rate)}</b>
                    <small style={{ color: "#64748b", display: "block", marginBottom: "8px" }}>
                      {s.billing === "monthly" ? "per month" : "per project"}
                    </small>

                    <div style={{ display: "flex", gap: "6px", justifyContent: "flex-end" }}>
                      <button
                        onClick={() => setActiveForm({ kind: "service", value: s })}
                        style={{ fontSize: "12px", padding: "4px 10px" }}
                      >
                        Edit
                      </button>
                      <button
                        className="danger"
                        onClick={() => {
                          if (confirm(`Delete service "${s.name}"?`)) {
                            deleteService(s.id);
                          }
                        }}
                        style={{ fontSize: "12px", padding: "4px 8px" }}
                      >
                        <i className="fa-solid fa-trash" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </section>
  );
};
